/// <reference path="../../../app.definition.ts" />


function ecvStaticChoices($timeout: ng.ITimeoutService, $compile: ng.ICompileService): ng.IDirective {
    return {
        restrict: 'A',
        require: 'uiSelect',
        replace: false,
        scope: false,
        link: (scope: ng.IScope, element, attributes: ng.IAttributes, $select): void => {
            // console.log("Linking static choices");
            const staticChoices = element.parent().find('.ecv-static-choice');
            // console.log("Static choices:", staticChoices);
            staticChoices.addClass('ui-select-choices-row');

            $timeout(() => {
                const choicesGroup = element.find('.ui-select-choices-group');
                let $el = staticChoices.clone();
                choicesGroup.prepend($el);
                $compile($el)(scope);
            }, 1);
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvStaticChoices', ['$timeout', '$compile', ecvStaticChoices]);
